import ProjectsComponent from "../Components/Projects/ProjectsComponent";
import PageWrapper from "../Components/PageWrapper/PageWrapper";

export default function Projects() {
  return (
    <PageWrapper>
      <ProjectsComponent />
    </PageWrapper>
  );
}
